  <qw>AZ</qw><template>
  <div class="content">
      <Aside :TreeIndex='updateTreeIndex'></Aside>
      <div class="Mbutton">
        <i v-show="flag" class="iconfont icon-jiantouzuo1 op-button" @click="handleClick"></i>
        <i v-show="!flag" class="iconfont icon-jiantouyou op-button" @click="handleClick"></i>
      </div>
      <router-view/>
    </div>
</template>

<script>
import Aside from '@/components/aside/Aside'
import {useStore} from 'vuex'
import {computed, ref,watch} from 'vue'
export default {
  name: 'RealErrorPage',
  components: {
    Aside
  },
  props:["TreeIndex"],
  // watch: {
  //   TreeIndex: {
  //     deep: true,
  //     handler(newValue, oldValue) {
  //       // console.log("总合 TreeIndex 变化：", newValue, oldValue);
  //       updateTreeIndex.value
  //     },
  //   },
  // },
  setup(prop, ctx) {
    watch(()=>prop.TreeIndex,(newV,oldV)=>{
      updateTreeIndex.value=prop.TreeIndex;
    });
    let updateTreeIndex=ref("");
    let store = useStore();
    let flag = computed(() => {
      return store.state.flag; 
    })
    let handleClick = (() => {
      // console.log('点击按钮');
      if (store.state.flag) {
        store.state.treeWidth = '0px';
        store.state.contentWidth = '30px';
        store.state.flag = false;
      } else {
        store.state.treeWidth = '230px';
        store.state.contentWidth = '270px';
        store.state.flag = true;
      }
    })
    let updateTree = ((param) => {
      console.log('updateTree',param);
    })
    return{
      handleClick,
      updateTree,
      updateTreeIndex,
      flag
    }
  }
}
</script>

<style lang="scss">
    .content{
      display: flex;
      width: 100%;
      margin-top: 10px;
    }
    .Mbutton{
      width: 20px;
      margin-right: 10px;
      margin-bottom: 10px;
      background-color: #2c3242;
      display: flex;
      .op-button{
        display: flex;
        color: #359186;
        width: 20px;
        height: 40px;
        margin: auto;
        align-items: center;
        justify-content: center;
        // text-align: center;
        background-color: #303749;
      }
    }
</style>